import Temp from "@/courier/Temp";

export default class CJLogisticShopX extends Temp {
  static CODE = "CJLX";

  constructor() {
    super(CJLogisticShopX.CODE);
  }

  getZone(item) {
    let type, to;
    let cross_price = 0;
    let remote_area = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));

    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);
    to = super.checkZone(prefixToPostCode);

    if (to == 1) {
      type = 1;
    } else {
      type = 2;
    }

    if (remote_area <= 0) {
      remote_area = super.checkRemoteArea(Number(item.fromPostcode));
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    if (new Date().getTime() < new Date("2021-10-01 00:00:00").getTime()) {
      return {
        index: item.index,
      };
    }

    return super.checkRules(item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getRemoteArea(addressRemote).then((res) => {
        resolve(res);
      });
    });
  }

  async checkRemoteAreaByCorrectorOrigin(addressRemote, postcode) {
    return new Promise((resolve) => {
      super.getRemoteArea(addressRemote, "cj").then((res) => {
        if (res) {
          resolve(100);
        } else {
          resolve(0);
        }
      });
    });
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }
}
